import './Footer.css';
import React from "react";
import { Container, Box, Typography } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material";
import TikTokIcon from "../../Assets/TikTok-Icon.svg";

function Footer() {
  return (
    <Box sx={{ bgcolor: "var(--bb-brand-color-6)" }}>
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            p: 5,
            gap: 3,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              Contact us
            </Typography>
            <Typography variant="body2">
              Email: contact-us@badensbagels.com
            </Typography>
            <Typography variant="body2" sx={{ display: "none" }}> {/* TODO Add when we have the phone number */}
              Tel: +44 1234 567890
            </Typography>
            <Box display="flex" gap={1} marginTop={ 1 }>
              <a href="https://www.instagram.com/badensbagels" target="_blank" rel="noopener noreferrer">
                <Instagram fontSize="large" sx={{ color: "black" }} />
              </a>
              <a href="https://www.facebook.com/people/Badens-Bagels/61573879535314" target="_blank" rel="noopener noreferrer">
                <Facebook fontSize="large" sx={{ color: "black" }} />
              </a>
              <a href="https://www.tiktok.com/@badensbagels" target="_blank" rel="noopener noreferrer">
                <img src={TikTokIcon} alt="TikTok" style={{ width: "27px", height: "27px", margin: "4px 3px" }} />
              </a>
            </Box>
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              Where we are
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Wednesday-Friday 7am-4pm:</strong> Cobalt Business Park
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Saturday-Sunday 9am-3:30pm:</strong> Tynemouth Market 
            </Typography>

            <Typography variant="body2" sx={{ textAlign: "end" }}>
              ©2025 Baden's Bagels
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
